import React, { PureComponent } from 'react';
import { DislikeOutlined, LikeOutlined } from '@ant-design/icons';
import { Button, Table, Radio } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import './test.scss';

import EntityDetails from '../../forms/EntityDetailsForm';

import { configureInfoDetails } from './detailsTableConfig';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
  },
  {
    title: 'Phone',
    dataIndex: 'phoneNumber',
  },
  {
    title: 'Email',
    dataIndex: 'email',
  },
];

export default class ManagePendingRequest extends PureComponent {
  static propTypes = {
    orgInfo: PropTypes.instanceOf(Array),
    rowIndex: PropTypes.number,
    orgType: PropTypes.string,
    requestType: PropTypes.string.isRequired,
    requestedAdmins: PropTypes.instanceOf(Array).isRequired,
    onSelectedRowKeysChange: PropTypes.func.isRequired,
    selectRow: PropTypes.func.isRequired,
    selectedRowKeys: PropTypes.instanceOf(Array).isRequired,
    onSelectedAction: PropTypes.func.isRequired,
    changeOrg: PropTypes.func.isRequired,
  };

  static defaultProps = {
    orgInfo: { value: 'viewReqs' },
    rowIndex: 0,
    orgType: null,
  };

  addKeys = requestedAdmins => {
    requestedAdmins.map((user, i) => {
      requestedAdmins[i].key = user.id;
      requestedAdmins[i].index = i;
      return user;
    });
    return requestedAdmins;
  };
  render() {
    const {
      orgInfo,
      rowIndex,
      requestedAdmins,
      onSelectedRowKeysChange,
      selectRow,
      selectedRowKeys,
      onSelectedAction,
      changeOrg,
      orgType,
      requestType,
    } = this.props;

    const infoItems = configureInfoDetails(orgInfo[rowIndex]);
    const rowSelection = {
      selectedRowKeys,
      onChange: onSelectedRowKeysChange,
    };
    return (
      <Container>
        {/* <Row>
          <Col xs="auto">
            <Button
              style={{
                backgroundColor: '#17a2b8',
                color: 'white',
                borderColor: '#17a2b8',
              }}
            >
              <Icon type="edit" />
              Edit this Entity
            </Button>
          </Col>
          <Col xs="auto" />
        </Row>
        <br /> */}
        <Row>
          <Col>
            <EntityDetails items={infoItems} />
          </Col>
          <Col>
            <div>
              Verify Organization Type:
              <div style={{ marginLeft: '1px', display: 'flex' }}>
                {/* this margin left is needed to get it on a new line dont know why its that way though */}
                <Radio.Group
                  defaultValue={orgType}
                  value={orgType}
                  onChange={changeOrg}
                  buttonStyle="solid"
                >
                  <Radio.Button value="common">Industry</Radio.Button>
                  <Radio.Button value="government">Government</Radio.Button>
                </Radio.Group>
              </div>
            </div>

            <div style={{ marginTop: '16px' }}>
              {requestType !== 'approved' && 'Select to Approve Org Admins:'}
              {requestType === 'approved' && 'Approved Organization Admins:'}
              <Table
                rowClassName={record => {
                  if (selectedRowKeys.includes(record.key)) {
                    return 'test1';
                  }
                  return '';
                }}
                rowSelection={requestType !== 'approved' && rowSelection}
                columns={columns}
                size="small"
                dataSource={this.addKeys(requestedAdmins)}
                onRow={record => ({
                  onClick: () => {
                    selectRow(record);
                  },
                })}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="auto">
            {requestType !== 'approved' && (
              <Button
                type="primary"
                onClick={() => {
                  onSelectedAction('approved');
                }}
              >
                <LikeOutlined />
                Approve
              </Button>
            )}
          </Col>
          <Col xs="auto">
            {requestType !== 'denied' && (
              <Button
                onClick={() => {
                  onSelectedAction('denied');
                }}
              >
                <DislikeOutlined />
                Deny Access
              </Button>
            )}
          </Col>
          <Col xs="auto">
            {/* <Button
              type="danger"
              onClick={() => {
                onSelectedAction('deleted');
              }}
            >
              <Icon type="delete" />
              Delete Organization
            </Button> */}
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/ManagePendingRequest/ManagePendingRequest.jsx